import React from "react";

interface CommentPlusIconProps {
    size?: string;
    color?: string;
}

const CommentPlusIcon = ({ size = "80", color = "#5A8DF1" }: CommentPlusIconProps) => {
    return (
<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50 37.5042V62.5042M37.5 50.0042H62.5M50 87.5C57.4168 87.5 64.667 85.3007 70.8339 81.1801C77.0007 77.0596 81.8072 71.2029 84.6455 64.3506C87.4838 57.4984 88.2264 49.9584 86.7794 42.6841C85.3325 35.4098 81.761 28.728 76.5165 23.4835C71.272 18.239 64.5902 14.6675 57.3159 13.2206C50.0416 11.7736 42.5016 12.5162 35.6494 15.3545C28.7971 18.1928 22.9404 22.9993 18.8199 29.1661C14.6993 35.333 12.5 42.5832 12.5 50C12.5 56.2 14 62.0417 16.6667 67.1959L12.5 87.5L32.8042 83.3333C37.9542 85.9958 43.8042 87.5 50 87.5Z" stroke="#79808A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    );
};

export default CommentPlusIcon;